import EventsList from "../components/EventsList";

const HamburgPage = () => EventsList('Hamburg')

export default HamburgPage